import { baseApiClient as api } from "../baseService";

export const addTagTypes = ["matters"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      mattersBulkCreate: build.mutation<
        MattersBulkCreateApiResponse,
        MattersBulkCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/bulk-matters/`,
          method: "POST",
          body: queryArg.bulkMatterCreateRequestSchema,
        }),
        invalidatesTags: ["matters"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type MattersBulkCreateApiResponse =
  /** status 201  */ BulkMatterCreateResponseSchema;
export type MattersBulkCreateApiArg = {
  bulkMatterCreateRequestSchema: BulkMatterCreateRequestSchema;
};
export type BulkMatterResultStatus = "created" | "duplicate" | "error";
export type BulkMatterResultItemSchema = {
  matter_name: string;
  external_cms_url: string;
  matter_id?: (string | string) | null;
  /** Status: created, duplicate, or error */
  status: BulkMatterResultStatus;
  error?: string | null;
};
export type BulkMatterCreateResponseSchema = {
  created?: BulkMatterResultItemSchema[];
  duplicates?: BulkMatterResultItemSchema[];
  errors?: BulkMatterResultItemSchema[];
  /** Summary counts of created, duplicates, and errors */
  summary: {
    [key: string]: number;
  };
};
export type MatterStatus =
  | "New Lead"
  | "Intake"
  | "Case Ingestion"
  | "Initial Review"
  | "Case Setup"
  | "Treatment"
  | "Treatment Complete"
  | "Ready for Demand"
  | "Demand Preparation"
  | "Demand Letter"
  | "Litigation"
  | "Complete"
  | "Hidden"
  | "In Progress"
  | "Client Dropped"
  | "To Be Dropped";
export type BulkMatterRowSchema = {
  /** Name of the matter */
  matter_name: string;
  /** External CMS URL for the matter */
  external_cms_url: string;
  /** Firm's unique matter email address (e.g., from Clio, Filevine) for correspondence tracking */
  cms_email?: string | null;
  /** Matter status */
  status?: MatterStatus;
};
export type BulkMatterCreateRequestSchema = {
  /** Firm ID to associate matters with */
  firm_id: string | string;
  /** List of matters to create */
  matters: BulkMatterRowSchema[];
  /** If true, performs validation without creating matters. Defaults to true. */
  dry_run?: boolean;
};
export const { useMattersBulkCreateMutation } = injectedRtkApi;
